import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import cx from 'classnames';

const styles = {
  root: {
    flexGrow: 1,
  },
  hidden: {
    opacity: 0,
    transition: 'opacity 0.3s',
  },
  visible: {
    opacity: 1,
  },
};

@withStyles(styles)
export default class LinearProgressLoader extends React.PureComponent {
  static displayName = 'LinearProgressLoader';
  static propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    // passed props
    total: PropTypes.number.isRequired,
    completed: PropTypes.number.isRequired,
    hide: PropTypes.bool,
  };

  static defaultProps = {
    styles: {},
    hide: false,
  };

  constructor() {
    super();
    this.state = {
      isHidden: false,
      isCompleted: false,
    };
  }

  async componentDidUpdate() {
    const { hide } = this.props;
    const { isCompleted } = this.state;

    if (!isCompleted && hide) {
      await this.sleep();
      this.setState({ // eslint-disable-line
        isHidden: true,
        isCompleted: true,
      });
    }
  }

  sleep() {
    return new Promise(resolve => setTimeout(() => resolve(), 500));
  }

  render() {
    const { classes, completed, total } = this.props;
    const { isHidden } = this.state;

    const progress = (completed / total) * 100;
    return (
      <div className={classes.root}>
        <LinearProgress
          className={cx({
            [classes.visible]: !isHidden,
            [classes.hidden]: isHidden,
          })}
          variant="determinate"
          value={progress}
        />
      </div>
    );
  }
}
